var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHospital(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.0169H20.7331V8.75H15.1419V16.0169H7.875V21.6081H15.1419V28.875H20.7331V21.6081H28V16.0169Z",
    fill: "url(#paint0_linear_6531_122203)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9825 18.025L38.5 12.0553V7.875C38.5 4.4975 35.7525 1.75 32.375 1.75H11.375C7.9975 1.75 5.25 4.4975 5.25 7.875V13.3919H8.75V7.875C8.75 6.42688 9.92688 5.25 11.375 5.25H32.375C33.8231 5.25 35 6.42688 35 7.875V50.75H28V40.25H15.75V50.75H8.75V24.2331H5.25V50.75C5.25 52.6794 6.82063 54.25 8.75 54.25H47.25C49.1838 54.25 50.75 52.6838 50.75 50.75V21.0656C50.75 19.8078 50.0741 18.6462 48.9825 18.025ZM24.5 50.75H19.25V43.75H24.5V50.75ZM47.25 50.75H38.5V36.75H43.75V33.25H38.5V29.75H43.75V26.25H38.5V16.0825L47.25 21.0656V50.75Z",
    fill: "url(#paint1_linear_6531_122203)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6531_122203",
    x1: 8.40148,
    y1: 10.3295,
    x2: 24.983,
    y2: 26.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F51836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#CA5AFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6531_122203",
    x1: 5.25,
    y1: 1.75,
    x2: 36.0413,
    y2: 61.7929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272135,
    stopColor: "#412A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658079,
    stopColor: "#34263B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHospital);
export default __webpack_public_path__ + "static/media/icon_hospital.7ec38c336f9bc1cfa0e7802040b25c6e.svg";
export { ForwardRef as ReactComponent };